import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AuthentificationService } from '../login/services/authentification.service';
import { LocalizationService } from '../shared/services/localization.service';
import { DashboardService } from '../shared/services/dashboard.service';
import { ChartOptions } from 'chart.js';
import { LoaderService } from '../shared/services/loader.service';
import { UIChart } from 'primeng/chart';
import { DatePipe } from '@angular/common';
import { WeekModel } from '../shared/models/week.model';
//import 'chartjs-plugin-labels';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, AfterViewInit {

    public isAdmin = false;

    public totalAbonneNumber = 425;
    public totalScanNumber = 1055;
    public totalPartnerNumber = 0;

    public abonBarChartOptions: ChartOptions = {
        plugins: {
            title: {
                display: true,
                position: 'bottom',
                fullSize: true,
                font: {
                    size: 18,
                    family: 'TT Wellingtons DemiBold'
                },
                color: '#414141',
                text: 'Nombres des nouveaux abonnés par mois'
            }
        },
        responsive: true
    };

    public scanBarChartOptions: ChartOptions = {
        plugins: {
            title: {
                display: true,
                position: 'bottom',
                fullSize: true,
                font: {
                    size: 18,
                    family: 'TT Wellingtons DemiBold'
                },
                color: '#414141',
                text: 'Nombres des scans par mois'
            }
        },
        responsive: true
    };

    public data = {
        labels: ['Homme', 'Femme'],
        datasets: [
            {
                data: [300, 100],
                backgroundColor: [
                    '#FF6384',
                    '#36A2EB'
                ],
                hoverBackgroundColor: [
                    '#FF6384',
                    '#36A2EB'
                ]
            }
        ]
    };

    public chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            }
        }
    };

    public choosenPeriode = [];

    public rapports = [
        {
            name: this.localizationService.translate('RAPPORTS.SUBSCRIBED_NUMBER'),
            code: 'RSN',
            withFilters: true,
            title: this.localizationService.translate('CLIENT.SUBSCRIBED_LABEL') + ('(s)')
        },
        {
            name: this.localizationService.translate('RAPPORTS.INSCRIT_NUMBER'),
            code: 'RIN',
            withFilters: true,
            title: this.localizationService.translate('CLIENT.INSCRIT_LABEL') + ('(s)')
        },
        {
            name: this.localizationService.translate('RAPPORTS.SUBSCRIBED_VS_INSCRIT_NUMBER'),
            code: 'RSVIN',
            withFilters: true,
            title: this.localizationService.translate('RAPPORTS.SUBSCRIBED_VS_INSCRIT_NUMBER')
        },
        {
            name: this.localizationService.translate('RAPPORTS.ALL_SCANS'),
            code: 'TS',
            withFilters: true,
            title: this.localizationService.translate('RAPPORTS.ALL_SCANS')
        },
        {
            name: this.localizationService.translate('RAPPORTS.SCANS_BY_CATEGORIE_PIE'),
            code: 'SPCP',
            withFilters: false,
            title: this.localizationService.translate('RAPPORTS.SCANS_BY_CATEGORIE_PIE')
        },
        {
            name: this.localizationService.translate('RAPPORTS.SCANS_BY_OFFERS'),
            code: 'SPO',
            withFilters: false,
            title: this.localizationService.translate('RAPPORTS.SCANS_BY_OFFERS')
        },
        {
            name: this.localizationService.translate('RAPPORTS.PARTNERS_NUMBER'),
            code: 'RPN',
            withFilters: true,
            title: this.localizationService.translate('RAPPORTS.PARTNERS_NUMBER')
        },
        {
            name: this.localizationService.translate('RAPPORTS.SCANS_BY_PARTNERS'),
            code: 'PPS',
            withFilters: false,
            title: this.localizationService.translate('RAPPORTS.SCANS_BY_PARTNERS')
        },
        {
            name: this.localizationService.translate('RAPPORTS.CA'),
            code: 'RCA',
            withFilters: true,
            title: this.localizationService.translate('RAPPORTS.CA')
        }
    ];

    selectedPeriod = [];

    selectedRapport = this.rapports[0];

    public values: any;

    public barChartLegend = false;

    public partnerChartData = { datasets: [], labels: [] };

    public scanChartDataSets = [{ data: [], label: '' }];

    public truncatedChartLabels = [];

    public scanPerCategoryPieData = {
        labels: [],
        datasets: [
            {
                data: [],
                backgroundColor: [],
                hoverBackgroundColor: []
            }
        ]
    };

    readonly CATEGORY_VOYAGE_COLOR = '#FFC400';
    readonly CATEGORY_RESTAURANT_COLOR = '#FF0018';
    readonly CATEGORY_BIEN_ETRE_COLOR = '#FF00A8';
    readonly CATEGORY_ACTIVITIES_COLOR = '#00CEFF';

    @ViewChild('scanPerCategoryChart') scanPerCategoryChart: UIChart;
    @ViewChild('scanPerSexAndDateChart') scanPerSexAndDateChart: UIChart;
    @ViewChild('scanPerSexPieChart') scanPerSexPieChart: UIChart;
    @ViewChild('scanPerDepartmentPieChart') scanPerDepartmentPieChart: UIChart;
    @ViewChild('scanPerOfferPieChart') scanPerOfferPieChart: UIChart;
    @ViewChild('usersPerSexAndDateChart') usersPerSexAndDateChart: UIChart;
    @ViewChild('usersPerSexPieChart') usersPerSexPieChart: UIChart;
    @ViewChild('RSVINLineChart') RSVINLineChart: UIChart;
    @ViewChild('partnersChart') partnersChart: UIChart;
    @ViewChild('caPerDateChart') caPerDateChart: UIChart;
    @ViewChild('billingTypePieChart') billingTypePieChart: UIChart;

    public frequencyChoice = [{ label: 'Hebdo', value: 'Hebdo' }, { label: 'Mensuel', value: 'Mensuel' }];
    public ageChoice = [{ label: '18-24', value: '24' }, { label: '25-40', value: '40' }, { label: '41 et +', value: '41' }];
    public frequency = 'Mensuel';
    public ages = [this.ageChoice[0]];

    public selectedYear = new Date().getFullYear();
    public years = [];

    public selectedZipCode = {
        label: 'Tous',
        value: 'all'
    };
    public zipCodes = [];

    public rsvinOptions = {
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    public rsvinData = {
        labels: [],
        datasets: []
    };


    public stackedData = {
        labels: [],
        datasets: []
    };
    public stackedOptions = {
        plugins: {
            tooltip: {
                mode: 'index',
                intersect: false
            }
        },
        responsive: true,
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true
            }
        }
    };


    public usersPerSexPieData = {
        labels: [],
        datasets: []
    }

    public scanPerAgePieData = {
        labels: [],
        datasets: []
    }

    public scanPerDepartmentPieData = {
        labels: [],
        datasets: []
    }

    public scanPerOfferPieData = {
        labels: [],
        datasets: []
    }

    public billingTypePieData = {
        labels: [],
        datasets: []
    }

    public usersPerSexPieOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            }
        }
    };

    public scanPerDepartmentPieOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            }
        }
    };
    private ONE_DAY_IN_MILLISECONDS = (24 * 60 * 60 * 1000);
    public maxSelectedWeeksNumber = 12;

    public rapportTitle = '';
    public periodeSelectedTitle = '';
    public totalElements = 0;

    constructor(private authenService: AuthentificationService,
        private localizationService: LocalizationService,
        private loaderService: LoaderService,
        private dashboardService: DashboardService,
        private datePipe: DatePipe) {
    }

    ngOnInit() {
        this.isAdmin = this.authenService.isAdmin();
        // this.fetchChartsData();
        this.getChartsInformation();
    }

    ngAfterViewInit(): void {
        this.ngOnInit();
    }

    public generatePeriods(initialCall?: boolean) {
        this.choosenPeriode = [];
        this.selectedPeriod = [];
        if (this.frequency === 'Mensuel') {
            this.setMonths(initialCall)
        } else {
            this.setWeeks();
        }
    }

    private setWeeks(): void {
        const firstDay = new Date(this.selectedYear, 0, 1);
        const currentYear = new Date().getFullYear();

        const dates = [];
        const day = firstDay.getDay(),
            diff = firstDay.getDate() - day + (day === 0 ? -6 : 1) - 1;
        let dateDebut = new Date(this.selectedYear, 0, 1);
        dates.push(dateDebut);
        dateDebut = new Date(dateDebut.getTime() + (diff * this.ONE_DAY_IN_MILLISECONDS));
        let lastDate = new Date();
        if (this.selectedYear !== currentYear) {
            lastDate = new Date(this.selectedYear + 1, 0, 1);
            lastDate = new Date(lastDate.getTime() - this.ONE_DAY_IN_MILLISECONDS);
        }
        while (dateDebut.getTime() < lastDate.getTime()) {
            dateDebut = new Date(dateDebut.getTime() + (7 * this.ONE_DAY_IN_MILLISECONDS));
            const dateFin = new Date(dateDebut.getTime() - (this.ONE_DAY_IN_MILLISECONDS));
            dates.push(dateFin);
            dates.push(dateDebut);
        }

        for (let i = 0; i < dates.length - 1; i += 2) {
            this.choosenPeriode.push({
                name: this.convertDateToString(dates[i]) + ' -- ' + this.convertDateToString(dates[i + 1]),
                value: this.convertDateToString(dates[i]),
                dateDebut: this.convertDateToString(dates[i]),
                dateFin: this.convertDateToString(dates[i + 1]),
            });
        }
    }

    private setMonths(initialCall?: boolean): void {
        let months = 11;
        if (this.selectedYear === new Date().getFullYear()) {
            months = new Date().getMonth() + 1
        }
        for (let i = 0; i < months; i++) {
            const currentMonth = new Date(this.selectedYear, i, 1)
            const nextMonth = new Date(new Date(this.selectedYear, i + 1, 1).getTime() - (this.ONE_DAY_IN_MILLISECONDS));
            this.choosenPeriode.push({
                name: this.convertDateToString(currentMonth) + ' -- ' + this.convertDateToString(nextMonth),
                value: this.convertDateToString(currentMonth),
                dateDebut: this.convertDateToString(currentMonth),
                dateFin: this.convertDateToString(nextMonth),
            });
        }
        if (initialCall) {
            this.choosenPeriode.forEach((item: any) => {
                this.selectedPeriod.push(item);
            });
        }
    }

    private convertDateToString(date: Date): string {
        return this.datePipe.transform(date, 'dd-MM-yyyy');
    }

    private getChartsInformation(): void {
        this.loaderService.startLoading();
        this.dashboardService.getChartInformation().subscribe((data: any) => {
            this.setZipCodesValues(data.zipCodes);
            this.setYears();
            this.generatePeriods(true);
            this.generateRapport();
        }, (err: any) => {
            this.loaderService.stopLoading();
            console.log('error while fetching chart informations');
        });
    }

    private setZipCodesValues(zipCodes: string[]): void {
        this.zipCodes = [];
        this.zipCodes.push({
            label: 'Tous',
            value: 'all'
        });
        const sortedZipCodes = zipCodes.sort();
        sortedZipCodes.forEach((item: string) => {
            this.zipCodes.push({
                label: item,
                value: item
            });
        });
    }

    private setYears(): void {
        this.years = [];
        const currentYear = new Date().getFullYear();
        for (let i = 0; i < 5; i++) {
            this.years.push({
                label: currentYear - i,
                value: currentYear - i
            })
        }
    }


    public generateRapport(): void {
        this.loaderService.startLoading();
        this.rapportTitle = this.selectedRapport.title;
        this.setSelectedPeriodTitle();
        switch (this.selectedRapport.code) {
            case 'RSN': {
                this.getSubscribedCountPerSexeBetweenDates();
                break;
            }
            case 'RIN': {
                this.getRegisteredCountPerSexBetweenDates();
                break;
            }
            case 'RSVIN': {
                this.getSubscribedVersusRegisteredClientsCountBetweenDates();
                break;
            }
            case 'TS': {
                this.getScanCountPerSexeBetweenDates();
                break;
            }
            case 'SPCP': {
                this.getCategoryByScanChartInfo();
                break;
            }
            case 'SPO': {
                this.getOfferByScanChartInfo();
                break;
            }
            case 'RPN': {
                this.getPartnersChart();
                break;
            }
            case 'PPS': {
                this.getPartnersByScanChartInfo();
                break;
            }
            case 'RCA': {
                this.getCaChartInfo();
                break;
            }
            default: {
                this.loaderService.stopLoading();
                break;
            }
        }
    }

    private getSubscribedCountPerSexeBetweenDates(): void {
        this.dashboardService.getSubscribedCountPerSexeBetweenDates(this.selectedYear, this.selectedPeriod.map(week => new WeekModel(week.dateDebut, week.dateFin).toStringURL()), this.ages.map(age => age.value), this.selectedZipCode.value).subscribe(
            (data: any) => {
                this.setValuesToStackedAndPieChart(data);
                this.loaderService.stopLoading();
            }, () => {
                this.loaderService.stopLoading();
            }
        );
    }

    private getRegisteredCountPerSexBetweenDates(): void {
        this.dashboardService.getRegisteredCountPerSexBetweenDates(this.selectedYear, this.selectedPeriod.map(week => new WeekModel(week.dateDebut, week.dateFin).toStringURL()), this.ages.map(age => age.value), this.selectedZipCode.value).subscribe(
            (data: any) => {
                this.setValuesToStackedAndPieChart(data);
                this.loaderService.stopLoading();
            }, () => {
                this.loaderService.stopLoading();
            }
        )
    };


    private getSubscribedVersusRegisteredClientsCountBetweenDates(): void {
        this.dashboardService.getSubscribedVersusRegisteredClientsCountBetweenDates(this.selectedYear, this.selectedPeriod.map(week => new WeekModel(week.dateDebut, week.dateFin).toStringURL()), this.ages.map(age => age.value), this.selectedZipCode.value).subscribe(
            (data: any) => {
                this.setValuesToRSVINChart(data);
                this.RSVINLineChart.reinit();
                this.loaderService.stopLoading();
            }, () => {
                this.loaderService.stopLoading();
            }
        );
    }

    private getScanCountPerSexeBetweenDates(): void {
        this.dashboardService.getScanCountPerSexeBetweenDates(this.selectedYear, this.selectedPeriod.map(week => new WeekModel(week.dateDebut, week.dateFin).toStringURL()), this.selectedZipCode.value).subscribe(
            (data: any) => {
                this.setValuesToStackedAndPieChart(data.scanCountPerSexeBetweenDates);
                // setup scan per age pie chart
                this.scanPerAgePieData = {
                    labels: ['18-24', '25-40', '40+'],
                    datasets: [
                        {
                            data: [data.lessThanTwentyFive, data.lessThanForty, data.olderThanForty],
                            backgroundColor: ['#fff100', '#fd9100', '#FF0018'],
                            hoverBackgroundColor: ['#fff100', '#fd9100', '#FF0018']

                        }
                    ]
                };

                // setup scan per department pie chart
                const departmentLabels = Object.keys(data.orderCountPerDepartment);
                const departmentValues = [];
                departmentLabels.forEach((key: string) => {
                    departmentValues.push(data.orderCountPerDepartment[key]);
                });

                this.scanPerDepartmentPieData = {
                    labels: departmentLabels,
                    datasets: [
                        {
                            data: departmentValues,
                            backgroundColor: ['#737373', '#c4c3c3', '#a8a8a8', '#d9d9d9', '#e1e1e1'],
                            hoverBackgroundColor: ['#737373', '#c4c3c3', '#a8a8a8', '#d9d9d9', '#e1e1e1']

                        }
                    ]
                };

                this.loaderService.stopLoading();
            }, () => {
                this.loaderService.stopLoading();
            }
        );
    }

    private setValuesToStackedAndPieChart(data: any) {
        this.setValuesToStackedData(data);
        if (this.usersPerSexAndDateChart) {
            this.usersPerSexAndDateChart.reinit();
        }
        if (this.usersPerSexPieChart) {
            this.usersPerSexPieChart.reinit();
        }
        if (this.scanPerSexAndDateChart) {
            this.scanPerSexAndDateChart.reinit();
        }
    }

    private getCategoryByScanChartInfo(): void {
        this.values = [];
        this.dashboardService.getCategoryByScanChartInfo().subscribe(
            (data: any) => {
                this.setPieValues(data);
                this.scanPerCategoryChart.reinit();
                this.loaderService.stopLoading();
            }, (err: any) => {
                this.loaderService.stopLoading();
                console.log(err);
            }
        );
    }

    private getOfferByScanChartInfo(): void {
        this.values = [];
        this.dashboardService.getOfferByScanChartInfo().subscribe(
            (data: any) => {
                this.values = data;
                this.loaderService.stopLoading();
            }, (err: any) => {
                this.loaderService.stopLoading();
                console.log(err);
            }
        );
    }

    private getPartnersChart(): void {
        const partnerData = [];
        const partnerLabel = [];
        this.totalPartnerNumber = 0;
        this.dashboardService.getPartnersChart(this.selectedYear, this.frequency === 'Mensuel', this.ages.map(age => age.value), this.selectedZipCode.value).subscribe(
            (data: any) => {
                Object.keys(data).map(key => {
                    partnerData.push(data[key]);
                    this.totalPartnerNumber += (+data[key]);
                    if (this.frequency === 'Mensuel') {
                        const monthAsNumber = +(key.substring(5, 7));
                        const month = new Date(this.selectedYear, monthAsNumber - 1, 1).toLocaleString('en', { month: 'long' }).toUpperCase()
                        partnerLabel.push(this.localizationService.translate('MONTHS.' + month));
                    } else {
                        partnerLabel.push(this.localizationService.translate(key));
                    }
                });
                this.partnerChartData = {
                    datasets: [{
                        backgroundColor: '#42A5F5',
                        data: partnerData,
                        label: ''
                    }], labels: partnerLabel
                };
                this.partnersChart.reinit();
                this.loaderService.stopLoading();
            }, (err: any) => {
                this.loaderService.stopLoading();
                console.log(err);
            }
        );
    }

    private getPartnersByScanChartInfo(): void {
        this.values = [];
        this.dashboardService.getPartnersByScanChartInfo().subscribe(
            (data: any) => {
                this.values = data;
                this.loaderService.stopLoading();
            }, (err: any) => {
                this.loaderService.stopLoading();
                console.log(err);
            }
        );
    }

    private getCaChartInfo(): void {
        this.dashboardService.getCAChart(this.selectedYear, this.selectedPeriod.map(week => new WeekModel(week.dateDebut, week.dateFin).toStringURL()), this.selectedZipCode.value).subscribe(
            (data: any) => {
                this.setCaChartInfo(data);
                this.caPerDateChart.reinit();
                this.billingTypePieChart.reinit();
                this.loaderService.stopLoading();
            }, (err: any) => {
                this.loaderService.stopLoading();
                console.log(err);
            }
        );
    }

    private setCaChartInfo(data: any): void {
        const billingTypes = ['MONTH', 'YEAR'];
        const monthData = [];
        const yearData = [];
        this.stackedData = {
            labels: [],
            datasets: []
        };
        this.billingTypePieData = {
            labels: [],
            datasets: []
        }
        Object.keys(data).map(key => {
            if (this.frequency === 'Mensuel') {
                const monthAsNumber = +(key.substring(5, 7));
                const month = new Date(this.selectedYear, monthAsNumber - 1, 1).toLocaleString('en', { month: 'long' }).toUpperCase()
                this.stackedData.labels.push(this.localizationService.translate('MONTHS.' + month));
            } else {
                this.stackedData.labels.push(this.localizationService.translate(key));
            }
            billingTypes.forEach(bType => {
                if (bType === 'MONTH') {
                    if (data[key][bType]) {
                        monthData.push(data[key][bType] / 100);
                    } else {
                        monthData.push(0);
                    }
                } else if (bType === 'YEAR') {
                    if (data[key][bType]) {
                        yearData.push(data[key][bType] / 100);
                    } else {
                        yearData.push(0);
                    }
                }
            });
        });
        this.stackedData.datasets = [{
            type: 'bar',
            label: 'Mensuel',
            backgroundColor: '#FF6384',
            data: monthData
        },
        {
            type: 'bar',
            label: 'Annuel',
            backgroundColor: '#36A2EB',
            data: yearData
        }];

        const totalYear = yearData.reduce((sum, current) => sum + current, 0);
        const totalMonth = monthData.reduce((sum, current) => sum + current, 0);

        this.billingTypePieData = {
            labels: ['Annuel', 'Mensuel'],
            datasets: [
                {
                    data: [totalYear, totalMonth],
                    backgroundColor: ['#36A2EB', '#FF6384'],
                    hoverBackgroundColor: ['#36A2EB', '#FF6384']

                }
            ]
        };
    }

    private setPieValues(data: any): void {
        const dataSetData = [];
        Object.keys(data).map(key => {
            this.scanPerCategoryPieData.labels.push(key);
            dataSetData.push(data[key]);
        });
        this.scanPerCategoryPieData.datasets[0].data = dataSetData;
        this.setPieColors();
    }

    private setPieColors(): void {
        this.scanPerCategoryPieData.labels.forEach((label: string) => {
            if (label === 'Activités') {
                this.scanPerCategoryPieData.datasets[0].backgroundColor.push(this.CATEGORY_ACTIVITIES_COLOR);
                this.scanPerCategoryPieData.datasets[0].hoverBackgroundColor.push(this.CATEGORY_ACTIVITIES_COLOR);
            } else if (label === 'Restaurants') {
                this.scanPerCategoryPieData.datasets[0].backgroundColor.push(this.CATEGORY_RESTAURANT_COLOR);
                this.scanPerCategoryPieData.datasets[0].hoverBackgroundColor.push(this.CATEGORY_RESTAURANT_COLOR);
            } else if (label === 'Bien-être') {
                this.scanPerCategoryPieData.datasets[0].backgroundColor.push(this.CATEGORY_BIEN_ETRE_COLOR);
                this.scanPerCategoryPieData.datasets[0].hoverBackgroundColor.push(this.CATEGORY_BIEN_ETRE_COLOR);
            } else if (label === 'Voyages') {
                this.scanPerCategoryPieData.datasets[0].backgroundColor.push(this.CATEGORY_VOYAGE_COLOR);
                this.scanPerCategoryPieData.datasets[0].hoverBackgroundColor.push(this.CATEGORY_VOYAGE_COLOR);
            } else {
                const randomColor = Math.floor(Math.random() * 16777215).toString(16);
                this.scanPerCategoryPieData.datasets[0].backgroundColor.push('#' + randomColor);
                this.scanPerCategoryPieData.datasets[0].hoverBackgroundColor.push('#' + randomColor);
            }
        });
    }

    private setValuesToStackedData(data: any): void {
        const sexes = ['Male', 'Female', 'Other'];
        const maleData = [];
        const femaleData = [];
        const otherData = [];
        this.stackedData = {
            labels: [],
            datasets: []
        };
        this.usersPerSexPieData = {
            labels: [],
            datasets: []
        }
        Object.keys(data).map(key => {
            if (this.frequency === 'Mensuel') {
                const monthAsNumber = +(key.substring(5, 7));
                const month = new Date(this.selectedYear, monthAsNumber - 1, 1).toLocaleString('en', { month: 'long' }).toUpperCase()
                this.stackedData.labels.push(this.localizationService.translate('MONTHS.' + month));
            } else {
                this.stackedData.labels.push(this.localizationService.translate(key));
            }
            sexes.forEach(sexe => {
                if (sexe === 'Female') {
                    if (data[key][sexe]) {
                        femaleData.push(data[key][sexe]);
                    } else if (data[key][sexe.toUpperCase()]) {
                        femaleData.push(data[key][sexe.toUpperCase()]);
                    } else {
                        femaleData.push(0);
                    }
                } else if (sexe === 'Male') {
                    if (data[key][sexe]) {
                        maleData.push(data[key][sexe]);
                    } else if (data[key][sexe.toUpperCase()]) {
                        maleData.push(data[key][sexe.toUpperCase()]);
                    } else {
                        maleData.push(0);
                    }
                } else {
                    if (data[key][sexe]) {
                        otherData.push(data[key][sexe]);
                    } else if (data[key][sexe.toUpperCase()]) {
                        otherData.push(data[key][sexe.toUpperCase()]);
                    } else {
                        otherData.push(0);
                    }
                }
            })
                ;
        });
        this.stackedData.datasets = [{
            type: 'bar',
            label: 'Femme',
            backgroundColor: '#FF00A8',
            data: femaleData
        },
        {
            type: 'bar',
            label: 'Homme',
            backgroundColor: '#00CEFF',
            data: maleData
        }, {
            type: 'bar',
            label: 'Autre',
            backgroundColor: '#FFC400',
            data: otherData
        }];

        const totalMale = maleData.reduce((sum, current) => sum + current, 0);
        const totalFemale = femaleData.reduce((sum, current) => sum + current, 0);
        const totalOther = otherData.reduce((sum, current) => sum + current, 0);

        this.totalElements = (totalMale + totalFemale + totalOther);

        this.usersPerSexPieData = {
            labels: ['Homme', 'Femme', 'Autre'],
            datasets: [
                {
                    data: [totalMale, totalFemale, totalOther],
                    backgroundColor: ['#00CEFF', '#FF00A8', '#FFC400'],
                    hoverBackgroundColor: ['#00CEFF', '#FF00A8', '#FFC400']

                }
            ]
        };

    }

    private setValuesToRSVINChart(data: any) {
        this.rsvinData.labels = [];

        const registeredData = [];
        const subscribedData = [];

        Object.keys(data['REG']).map(month => {
            if (this.frequency === 'Mensuel') {
                const monthAsNumber = +(month.substring(5, 7));
                const monthKey = new Date(this.selectedYear, monthAsNumber - 1, 1).toLocaleString('en', { month: 'long' }).toUpperCase()
                this.rsvinData.labels.push(this.localizationService.translate('MONTHS.' + monthKey));
            } else {
                this.rsvinData.labels.push(this.localizationService.translate(month));
            }
            registeredData.push(data['REG'][month]);
        });
        Object.keys(data['SUB']).map(month => {
            subscribedData.push(data['SUB'][month]);
        });
        this.rsvinData.datasets = [{
            label: 'Inscrit',
            data: registeredData,
            fill: false,
            borderColor: '#42A5F5',
            tension: .4
        },
        {
            label: 'Abonné',
            data: subscribedData,
            fill: false,
            borderColor: '#FFA726',
            tension: .4
        }];

    }

    private setSelectedPeriodTitle(): void {
        this.periodeSelectedTitle = '';
        if (this.frequency === 'Mensuel') {
            this.selectedPeriod.forEach((item: any, index: number) => {
                const month = new Date(this.selectedYear, (item.value.substring(3, 5)) - 1, 1).toLocaleString('en', { month: 'long' }).toUpperCase()
                this.periodeSelectedTitle += (index === 0 ? '' : ', ') + this.localizationService.translate('MONTHS.' + month);
            });
            this.periodeSelectedTitle += ' ' + this.selectedYear;
        } else {
            this.periodeSelectedTitle = this.selectedPeriod.length + ' Semaines de ' + this.selectedYear
        }
    }
}
